export const HOCLockingEvents = ({
  children,
  captureEventsNames,
  lockingEventsExpression,
  otherProps,
  singleMode,
}: {
  children: any;
  captureEventsNames: string[];
  lockingEventsExpression: boolean;
  otherProps?: { [propName: string]: any };
  singleMode?: boolean; //TODO:чтобы не было перерендеров (одна обёртка без разницы дизейбл или нет).
  // В будущем убрать и сделать чтобы ВСЕГДА так и работало, как сейчас через пропс singleMode
  // (пока сделано отдельным ретурном, чтобы точно не сломать место где уже использовалось это раньше)
}) => {
  if (singleMode) {
    return (
      <div
        className={'HOCLockingWrapper'}
        {...otherProps}
        {...captureEventsNames.reduce(
          (acc: { [propName: string]: any }, eventName) => (
            (acc[`${eventName}Capture`] = (e: any) =>
              lockingEventsExpression && e.stopPropagation()),
            acc
          ),
          {}
        )}
      >
        {children}
      </div>
    );
  }

  return lockingEventsExpression ? (
    <div
      className={'HOCLockingWrapper'}
      {...otherProps}
      {...captureEventsNames.reduce(
        (acc: { [propName: string]: any }, eventName) => (
          (acc[`${eventName}Capture`] = (e: any) => e.stopPropagation()), acc
        ),
        {}
      )}
    >
      {children}
    </div>
  ) : (
    <>{children}</>
  );
};
